// ACF Tourism - Mock Data

export const airports = [
  { code: 'BOM', city: 'Mumbai', country: 'India', name: 'Mumbai Intl Airport' },
  { code: 'DXB', city: 'Dubai', country: 'UAE', name: 'Dubai Intl Airport' },
  { code: 'DEL', city: 'Delhi', country: 'India', name: 'Indira Gandhi Intl Airport' },
  { code: 'LKO', city: 'Lucknow', country: 'India', name: 'Chaudhary Charan Singh Intl Airport' },
  { code: 'SHJ', city: 'Sharjah', country: 'UAE', name: 'Sharjah Intl Airport' },
  { code: 'AUH', city: 'Abu Dhabi', country: 'UAE', name: 'Abu Dhabi Intl Airport' },
  { code: 'MLE', city: 'Male', country: 'Maldives', name: 'Velana Intl Airport' },
  { code: 'DPS', city: 'Bali', country: 'Indonesia', name: 'Ngurah Rai Intl Airport' },
  { code: 'BKK', city: 'Bangkok', country: 'Thailand', name: 'Suvarnabhumi Airport' },
  { code: 'IKA', city: 'Tehran', country: 'Iran', name: 'Imam Khomeini Intl Airport' },
  { code: 'GOI', city: 'Goa', country: 'India', name: 'Dabolim Airport' },
  { code: 'CCU', city: 'Kolkata', country: 'India', name: 'Netaji Subhas Chandra Bose Intl' },
  { code: 'MAA', city: 'Chennai', country: 'India', name: 'Chennai Intl Airport' },
  { code: 'BLR', city: 'Bangalore', country: 'India', name: 'Kempegowda Intl Airport' },
];

export const airlines = [
  { code: 'IX', name: 'Akasa', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c4/Akasa_Air_logo.svg/200px-Akasa_Air_logo.svg.png' },
  { code: 'SG', name: 'SpiceJet', logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/0/09/SpiceJet_logo.svg/200px-SpiceJet_logo.svg.png' },
  { code: 'G9', name: 'Air Arabia', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/5e/Air_Arabia_Logo.svg/200px-Air_Arabia_Logo.svg.png' },
  { code: '6E', name: 'IndiGo', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/69/IndiGo_Airlines_logo.svg/200px-IndiGo_Airlines_logo.svg.png' },
  { code: 'AI', name: 'Air India', logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/3/3e/Air_India_Logo.svg/200px-Air_India_Logo.svg.png' },
  { code: 'EK', name: 'Emirates', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Emirates_logo.svg/200px-Emirates_logo.svg.png' },
  { code: 'EY', name: 'Etihad Airways', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Etihad-airways-logo.svg/200px-Etihad-airways-logo.svg.png' },
  { code: 'IX2', name: 'Air India Express', logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Air_India_Express_Logo.svg/200px-Air_India_Express_Logo.svg.png' },
  { code: 'MS', name: 'Egypt Air', logo: 'https://upload.wikimedia.org/wikipedia/en/thumb/3/3e/EgyptAir_logo.svg/200px-EgyptAir_logo.svg.png' },
];

export const destinations = [
  {
    id: 1,
    name: 'DUBAI',
    image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?w=600&h=400&fit=crop',
    description: 'City of Gold',
    startingPrice: 11973,
  },
  {
    id: 2,
    name: 'MALDIVES',
    image: 'https://images.unsplash.com/photo-1637576308588-6647bf80944d?w=600&h=400&fit=crop',
    description: 'Paradise on Earth',
    startingPrice: 25000,
  },
  {
    id: 3,
    name: 'BALI',
    image: 'https://images.pexels.com/photos/35343781/pexels-photo-35343781.jpeg?w=600&h=400&fit=crop',
    description: 'Island of the Gods',
    startingPrice: 18500,
  },
  {
    id: 4,
    name: 'THAILAND',
    image: 'https://images.unsplash.com/photo-1627391593232-ecc997f1527f?w=600&h=400&fit=crop',
    description: 'Land of Smiles',
    startingPrice: 15200,
  },
  {
    id: 5,
    name: 'IRAN',
    image: 'https://images.unsplash.com/photo-1658490250951-19794915f53c?w=600&h=400&fit=crop',
    description: 'Land of Rich Heritage',
    startingPrice: 22000,
  },
];

export const sampleFlights = [
  {
    id: 1,
    airline: 'Akasa',
    airlineCode: 'IX',
    flightNumber: 'IX251',
    departureTime: '14:55',
    departureAirport: 'BOM',
    arrivalTime: '16:50',
    arrivalAirport: 'SHJ',
    duration: '3h 25m',
    stops: 'Non Stop',
    price: 11973,
    class: 'Economy',
  },
  {
    id: 2,
    airline: 'SpiceJet',
    airlineCode: 'SG',
    flightNumber: 'SG59',
    departureTime: '02:00',
    departureAirport: 'BOM',
    arrivalTime: '03:55',
    arrivalAirport: 'DXB',
    duration: '3h 25m',
    stops: 'Non Stop',
    price: 13653,
    class: 'Economy',
  },
  {
    id: 3,
    airline: 'Air Arabia',
    airlineCode: 'G9',
    flightNumber: 'G9406',
    departureTime: '04:55',
    departureAirport: 'BOM',
    arrivalTime: '06:55',
    arrivalAirport: 'DXB',
    duration: '3h 10m',
    stops: 'Non Stop',
    price: 13570,
    class: 'Economy',
  },
  {
    id: 4,
    airline: 'IndiGo',
    airlineCode: '6E',
    flightNumber: '6E1511',
    departureTime: '02:00',
    departureAirport: 'BOM',
    arrivalTime: '04:00',
    arrivalAirport: 'DXB',
    duration: '3h 30m',
    stops: 'Non Stop',
    price: 14292,
    class: 'Economy',
  },
  {
    id: 5,
    airline: 'IndiGo',
    airlineCode: '6E',
    flightNumber: '6E1511',
    departureTime: '15:20',
    departureAirport: 'BOM',
    arrivalTime: '17:20',
    arrivalAirport: 'DXB',
    duration: '3h 30m',
    stops: 'Non Stop',
    price: 14292,
    class: 'Economy',
  },
  {
    id: 6,
    airline: 'IndiGo',
    airlineCode: '6E',
    flightNumber: '6E1511',
    departureTime: '18:25',
    departureAirport: 'BOM',
    arrivalTime: '20:25',
    arrivalAirport: 'DXB',
    duration: '3h 30m',
    stops: 'Non Stop',
    price: 14292,
    class: 'Economy',
  },
  {
    id: 7,
    airline: 'Etihad Airways',
    airlineCode: 'EY',
    flightNumber: 'EY203',
    departureTime: '13:10',
    departureAirport: 'BOM',
    arrivalTime: '22:40',
    arrivalAirport: 'DXB',
    duration: '10h 30m',
    stops: '1 Stop AUH',
    price: 20443,
    class: 'Economy',
  },
  {
    id: 8,
    airline: 'Emirates',
    airlineCode: 'EK',
    flightNumber: 'EK508',
    departureTime: '10:25',
    departureAirport: 'BOM',
    arrivalTime: '12:10',
    arrivalAirport: 'DXB',
    duration: '3h 15m',
    stops: 'Non Stop',
    price: 35813,
    class: 'Economy',
  },
  {
    id: 9,
    airline: 'Air India Express',
    airlineCode: 'IX2',
    flightNumber: 'IX383',
    departureTime: '08:30',
    departureAirport: 'BOM',
    arrivalTime: '10:45',
    arrivalAirport: 'DXB',
    duration: '3h 45m',
    stops: 'Non Stop',
    price: 12550,
    class: 'Economy',
  },
  {
    id: 10,
    airline: 'Air India',
    airlineCode: 'AI',
    flightNumber: 'AI995',
    departureTime: '21:00',
    departureAirport: 'BOM',
    arrivalTime: '23:15',
    arrivalAirport: 'DXB',
    duration: '3h 45m',
    stops: 'Non Stop',
    price: 18750,
    class: 'Economy',
  },
];

export const datePrices = [
  { date: 'Thu, Dec 05', price: 11973, day: 'Thursday' },
  { date: 'Fri, Dec 06', price: null, day: 'Friday' },
  { date: 'Sat, Dec 07', price: 10250, day: 'Saturday' },
  { date: 'Sun, Dec 08', price: null, day: 'Sunday' },
  { date: 'Mon, Dec 09', price: 12780, day: 'Monday' },
  { date: 'Tue, Dec 10', price: 13585, day: 'Tuesday' },
  { date: 'Wed, Dec 11', price: null, day: 'Wednesday' },
  { date: 'Thu, Dec 12', price: 14995, day: 'Thursday' },
  { date: 'Fri, Dec 13', price: null, day: 'Friday' },
];

export const promoCode = {
  code: 'ACFNEW110',
  discount: 10,
  message: 'Get 10% Additional Discount on your first Booking!',
};
